import { inject, provideAppInitializer, Provider } from '@angular/core';
import { EnumTools } from '../tools/enum-tools';
import { Theme, ThemeService } from '../services/theme.service';

export function provideSolTheme(themeString?: string): Provider {
  return [
    provideAppInitializer(() => {
      const themeStore = inject(ThemeService);
      const defaultTheme = EnumTools.fromString(Theme, themeString) || Theme.SOL_LIGHT;
      themeStore.initialize(defaultTheme);
    }),
  ];
}
